<template>
<div class="chapter">
<div class="inner_page">
<h1>Why Authors Go Wrong</h1>
<h2 class="sigil_not_in_toc">And Other Explanations</h2>
<h3 class="sigil_not_in_toc">Grant M. Overton</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?39cd8d62